import { UPDATE_ACTIONS } from './updateActions';
import { SUPER_BATCH_TYPES } from 'data/superBatchTypes';

export const SCHEDULED_CLASSES_VISIBILITY_DATA = {
  [UPDATE_ACTIONS.add]: {
    [SUPER_BATCH_TYPES.secondary]:
      'Scheduled Classes will be visible in the <b>’Active Section’</b>',
    [SUPER_BATCH_TYPES.crashCourse]:
      'Scheduled Classes will be visible in the <b>‘Additional Live Content’</b>',
  },
  [UPDATE_ACTIONS.remove]: {
    [SUPER_BATCH_TYPES.secondary]: 'The future classes will be removed',
    [SUPER_BATCH_TYPES.crashCourse]: 'The future classes will be removed',
  },
};
